
import { Component, Inject, OnInit, DOCUMENT } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { FooterContainerComponent } from './footer/footer.container.component';

enum Mode {
  DARK = 'dark',
  LIGHT = 'light',
}

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  imports: [RouterOutlet, FooterContainerComponent],
})
export class AppComponent implements OnInit {
  window!: Window;
  currentMode: string = 'dark';

  constructor(@Inject(DOCUMENT) private document: Document) {}

  ngOnInit() {
    // const deviceMode = window.matchMedia("(prefers-color-scheme: dark)");
    let initMode: Mode = this.getMode(); // this.modeStorage.get();
    // if (!initMode) {
    //   deviceMode.matches ? (initMode = Mode.DARK) : (initMode = Mode.LIGHT);
    // }
    this.updateCurrentMode(initMode);
  }

  getMode(): Mode {
    const deviceMode = window.matchMedia('(prefers-color-scheme: dark)');
    return deviceMode && deviceMode.matches && false ? Mode.DARK : Mode.LIGHT;
  }

  updateCurrentMode(initMode: Mode) {
    this.document.body.classList.add(initMode);
  }
}
